const state = {
  error: null,
  data: null,
  uploaded: false,
  uploading: false
}

export default state
